/** Pushed when a file's discussion thread changes (message/anchor created/updated/deleted). */
export interface FileReviewThreadChangedNotice {
  resourceKey: string;
  changeType: string;
  changedByUserId: string | null;
  changedByDisplayName: string | null;
  changedAtUtc: string;
}

export const FILE_REVIEW_HUB_PATH = '/hubs/file-review';
